/**
 * Public display price of a single full report.
 *
 * Ported from the legacy application's `src/lib/pricing.ts` (V2-018C-2
 * migration), where the marketing pages interpolate it into copy.
 *
 * **Display only.** Nothing here authorises a charge. The amount actually
 * charged is resolved server-side from Stripe by `lookup_key` in
 * `apps/api/src/lib/pricing.ts`, which cross-checks Stripe's `unit_amount`
 * against `products.display_price_cents` and fails closed on a mismatch. These
 * constants never participate in that path.
 *
 * What `test/pricing.test.ts` actually asserts, and nothing beyond it:
 *
 *   1. `REPORT_PRICE` and `REPORT_PRICE_CENTS` agree with each other.
 *   2. No executable raw price literal exists anywhere in `src` outside this
 *      file, so every rendered price reads from here.
 *
 * It does **not** validate Stripe, the product catalogue, or the database
 * `display_price_cents` column — those are separate systems with their own
 * guards, and this module has no access to any of them. The catalogue value is
 * asserted independently in `supabase/tests/reference_data.test.sql`. An
 * earlier version of this comment claimed the cross-system agreement was
 * tested here; it was not, and the claim is removed rather than weakened.
 */
export const REPORT_PRICE = 19.99;

/**
 * The same price in cents.
 *
 * Exists so the dollar figure has something to be checked against inside the
 * browser workspace. It is written to match the launch catalogue, but that
 * correspondence is a convention this file cannot verify — see above.
 */
export const REPORT_PRICE_CENTS = 1999;
